module.exports = __webpack_public_path__ + "static/media/arrow-ios-up.db10e910.svg";